<template>
  <div class="page-wrap text-center">
    <div class="session-form-hold">
      <v-card
        class="rounded-lg d-flex flex-column gap-6 align-center pa-7 rounded-xl"
      >
        <img
          src="/img/logo/logo-dark.png"
          style="max-width: 250px"
          class="rounded-0"
        />
        <div v-if="!unlicenced">
          <h4>Licença expirada</h4>
          <p class="">
            A plataforma está desativada pois não possui uma licença válida.
            Entre em contato com o suporte para mais informações.
          </p>

          <v-divider class="my-4"></v-divider>
          <v-alert outlined color="primary" text class="mb-0" dense>
            <div class="d-flex gap-3 align-center">
              <!-- <img
                style="width: 45px"
                src="/img/logo/tiqone-light.png"
                alt=""
              /> -->
              <div>
                <b>Quer ter sua própria tiqueteira?</b>
                <small class="d-block lh-1">
                  Entre em contato e tenha a melhor negociação do mercado
                </small>
                <v-btn
                  href="//wa.me/5521988471167?text=Olá, gostaria de saber mais sobre ter minha própria tiqueteira"
                  target="_blank"
                  color="info"
                  block
                  small
                  depressed
                  class="mt-2"
                >
                  Entre em contato
                </v-btn>
              </div>
            </div>
          </v-alert>
        </div>
        <div v-else>
          <h4>Estamos em manutenção</h4>
          <p class="mb-0">
            Estamos trabalhando para melhorar o nosso site. Por favor, volte
            mais tarde.
          </p>
        </div>
      </v-card>
      <div class="d-flex justify-center mt-4">
        <a
          href="https://tiq.one"
          class="d-flex gap-2 align-center"
          target="_blank"
        >
          <small class="grey--text text--lighten-2"> Powered By </small>
          <img style="width: 50px" src="/img/logo/tiqone-light.png" alt="" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { active } from "@/themeConfig.js";
import moment from "moment";

export default {
  name: "Maintenance",
  data() {
    return {
      active,
    };
  },
  methods: {},
  computed: {
    unlicenced() {
      const licenceUntil = process.env.VUE_APP_LICENCE_UNTIL;
      if (!licenceUntil) return false;
      return moment(licenceUntil).endOf("day").isBefore(moment());
    },
  },
};
</script>

<style lang="scss" scoped>
.page-wrap {
  background: radial-gradient(
      circle at 50% 50%,
      rgba(0, 0, 0, 50%) 0%,
      rgba(0, 0, 0, 90%) 90vw
    ),
    url(/img/logo/auth-background.png), black;
  display: flex;
  background-size: cover;
  background-position: center;
  align-items: center;
  padding: 40px 1rem;
  height: 100%;
  min-height: 100vh;
}

.session-form-hold {
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
}
</style>
